module.exports = __webpack_public_path__ + "img/chuangsai_28.5dabf03c.jpg";